import { Inject, Injectable, Output, EventEmitter } from '@angular/core';
import { Headers, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { AdalService } from '../shared/azure-authentication/adal.service';
import { BaseEndpoint } from '../app.constants';
import { Team } from './team.model';
import { User } from '../users/user.model';
import { TreeModel } from './tree.model';

@Injectable()
export class TeamService {
    private teams: Team[] = [];
    @Output() requestAdded: EventEmitter<any[]> = new EventEmitter<any[]>();

    constructor(
        private http: Http,
        @Inject(BaseEndpoint) private baseApiUrl: string,
        private adalService: AdalService) {
    }

    getTeam(id: string): Promise<Team> {
        var url = this.baseApiUrl + "v1/teams/" + id;
        return this.http
            .get(url, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                return resp.json().body as Team;
            })
            .catch(this.handleError);
    }

    getTeams(): Promise<Team[]> {
        var url = this.baseApiUrl + 'v1/teams';
        return this.http
            .get(url, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
              this.teams = resp.json().body as Team[];
                return this.teams;
            })
            .catch(this.handleError);
    }

    getTeamsByUserId(userId: string): Promise<Team[]> {
        var url = this.baseApiUrl + 'v1/teams?userId=' + userId;
        return this.http
            .get(url, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                return resp.json().body as Team[];
            })
            .catch(this.handleError);
    }

    getTeamsCache(): Promise<Team[]> {
        if (this.teams.length == 0)
        {
            return this.getTeams();
        }
        else
        {
            var promise = new Promise<Team[]>((resolve, reject) => {
                resolve(this.teams);
            });
            return promise;
        }
    }

    updateTeam(teamId: string, team: Team): Promise<Team> {
        var url = this.baseApiUrl + 'v1/team/' + teamId;
        return this.http
            .put(url, team, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {               
                var updatedTeam = resp.json().body as Team;
                var oldTeam = this.teams.find(t => t.id == teamId);
                oldTeam.name = updatedTeam.name;
                oldTeam.partnerCount = updatedTeam.partnerCount;
                return updatedTeam;
            })
            .catch(this.handleError);
    }

    addTeam(team: Team): Promise<Team> {
        var url = this.baseApiUrl + 'v1/teams';
        return this.http
            .post(url, team, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
            const newTeam = resp.json().body as Team;
              if (newTeam != null) {
                this.teams.push(newTeam);
              }
              else this.handleError("Could not add team - team is already active");
                return newTeam;
            })
            .catch(this.handleError);
    }

    getTeamTree(teamId: string): Promise<TreeModel> {
        var url = this.baseApiUrl + 'v1/tree/' + teamId;
        return this.http
            .get(url, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
              var teams = resp.json().body as TreeModel[];
                return teams;
            })
            .catch(this.handleError);
    }

    deleteTeam(teamId: string): Promise<boolean> {
        var url = this.baseApiUrl + 'v1/team/' + teamId;
        return this.http
            .delete(url, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                var success = !resp.json().hasErrors as boolean;

                if (success) {
                    var teamIndex = this.teams.findIndex(t => t.id == teamId);
                    this.teams.splice(teamIndex, 1);
                }

                return success;
            })
            .catch(this.handleError);
    }

    getTeamUsersWithPersona(teamId: string, persona: string): Promise<User[]> {
        var url = this.baseApiUrl + 'v1/users/' + teamId + '/' + persona;
        return this.http
            .get(url, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                var teams = resp.json().body as User[];
                return teams;
            })
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/teams/team.service.ts